import { Accordion } from '../building-blocks/accordion/accordion';
import '../../common/css/style.css';

// Блог або новини – статті про танці, лайфхаки, анонси подій
// ✅ Часті питання (FAQ) – відповіді на популярні питання щодо занять
// ✅ Окремий розділ для Pro-Am – якщо хочеш залучити дорослих учнів

const FAQ_ITEMS = [
  {
    question: 'Який одяг взяти на перше тренування?',
    answer: 'Вибрати треба зручний одяг👍',
  },
  {
    question: 'Чи підійдуть заняття для моєї дитини?',
    answer:
      'Багаторічний досвід та персональний підхід наших педагогів дозволить у повній мірі розкрити потенціал Вашої дитини',
  },
  {
    question: 'З якого віку можна розпочати заняття?',
    answer:
      'Ми набираємо дітей з 3 років у наймолодшу групу, а також проводимо заняття для старших дітей та дорослих',
  },
  {
    question: 'Чи можна прийти на пробне заняття?',
    answer:
      'Так, перед тим як придбати абонемент, можна відвідати пробне заняття та познайомитися з тренерами й групою',
  },
];

const faqStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: FAQ_ITEMS.map(({ question, answer }) => ({
    '@type': 'Question',
    name: question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: answer,
    },
  })),
};

export const Faq = () => {
  return (
    <div id="faq" className="main-style">
      <div className="section-wrapper">
        <h2 className="container-title">Часті питання ❓</h2>
        <div style={{ margin: '16px 0 0' }}>
          {FAQ_ITEMS.map(({ question, answer }) => (
            <Accordion key={question} title={question} children={answer} />
          ))}
        </div>
      </div>
      <script
        type="application/ld+json"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqStructuredData) }}
      />
    </div>
  );
};
